export const encodeUnicodeToBase64 = (str: string): string => {
  return btoa(encodeURIComponent(str));
};

export const decodeBase64ToUnicode = (base64: string): string => {
  return decodeURIComponent(atob(base64));
};
